const lisboa1 = '7d139b52-372d-4f39-93fc-40f3c0a37955';
const lisboa2 = '85c5dbbb-0060-4dfb-8f95-78a26b3129bf';
const lisboa3 = '1e1fee34-22f7-44c9-b434-6e1d99c5026c';
const lisboa4 = '1887c14d-bc09-413a-92d9-8482c366f2bf';
const lisboa5 = '3700ff98-fb11-4fb4-9e4a-1bc24f97c543';

const porto1 = '36a71a74-22c5-4366-b6e2-b27e3acd02b2';
const porto2 = 'f1d8199b-21b2-4042-95ef-b7f0dcbdc06d';
const porto3 = 'e42dcf38-771f-4088-8002-a88a9c8f6378';

const SP_BLOCKS = require('./blocks');

const getBlockName = function(id) {
  return SP_BLOCKS[id].name || '';
};

module.exports = {
  '23d97e24-99c2-4520-b1c8-09e182fdf9d0': {
    name: 'Lisboa 1-001',
    module: [[{ id: lisboa1, name: getBlockName(lisboa1) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  '29ad7b4d-25cd-44bb-9e06-d3fcc3eed182': {
    name: 'Lisboa 2-001',
    module: [[{ id: lisboa2, name: getBlockName(lisboa2) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  '03cecbb5-aafe-4c7e-ba6a-f7c331a24eea': {
    name: 'Lisboa 2-002',
    module: [[{ id: lisboa2, name: getBlockName(lisboa2), r: 90 }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  '332eb4b9-c33c-4aaa-967d-58bae5309545': {
    name: 'Lisboa 3-001',
    module: [[{ id: lisboa3, name: getBlockName(lisboa3) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  'd0acfa61-0063-4424-8df2-da4f98254fb8': {
    name: 'Lisboa 4-001',
    module: [[{ id: lisboa4, name: getBlockName(lisboa4) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  '3fbad118-6526-40db-864a-38807f4a7390': {
    name: 'Lisboa 4-002',
    module: [
      [180, 270, 180, 270, 180, 270],
      [180, 0, 90, 0, 90, 270],
      [0, 180, 0, 90, 270, 90],
      [270, 90, 270, 180, 0, 180],
      [90, 270, 180, 270, 180, 0],
      [90, 0, 90, 0, 90, 0],
    ].map(row =>
      row.map(r => ({ id: lisboa4, name: getBlockName(lisboa4), r }))
    ),
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  '244c939e-eed5-428c-846f-9e4737ce53c3': {
    name: 'Lisboa 5-001',
    module: [[{ id: lisboa5, name: getBlockName(lisboa5) }]],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  '48cc25cb-55f7-47f3-9fef-ddc5a450d85d': {
    name: 'Lisboa 5-002',
    module: [
      [
        { id: lisboa5, name: getBlockName(lisboa5) },
        { id: lisboa5, name: getBlockName(lisboa5), r: 180 },
      ],
      [
        { id: lisboa5, name: getBlockName(lisboa5), r: 180 },
        { id: lisboa5, name: getBlockName(lisboa5) },
      ],
    ],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  'c7004e30-d53a-42dc-b64f-7676f788b818': {
    name: 'Lisboa All-001',
    module: [
      [
        { id: lisboa5, name: getBlockName(lisboa5), r: 90 },
        { id: lisboa1, name: getBlockName(lisboa1) },
        { id: lisboa5, name: getBlockName(lisboa5) },
        { id: lisboa5, name: getBlockName(lisboa5), r: 90 },
        { id: lisboa1, name: getBlockName(lisboa1) },
        { id: lisboa5, name: getBlockName(lisboa5) },
      ],
      [
        { id: lisboa2, name: getBlockName(lisboa2) },
        { id: lisboa1, name: getBlockName(lisboa1) },
        { id: lisboa2, name: getBlockName(lisboa2) },
        { id: lisboa2, name: getBlockName(lisboa2) },
        { id: lisboa1, name: getBlockName(lisboa1) },
        { id: lisboa2, name: getBlockName(lisboa2) },
      ],
      [
        { id: lisboa5, name: getBlockName(lisboa5), r: 270 },
        { id: lisboa5, name: getBlockName(lisboa5), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2) },
        { id: lisboa5, name: getBlockName(lisboa5), r: 270 },
        { id: lisboa5, name: getBlockName(lisboa5), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2) },
      ],
      [
        { id: lisboa1, name: getBlockName(lisboa1) },
        { id: lisboa2, name: getBlockName(lisboa2) },
        { id: lisboa2, name: getBlockName(lisboa2) },
        { id: lisboa5, name: getBlockName(lisboa5) },
        { id: lisboa3, name: getBlockName(lisboa3) },
        { id: lisboa5, name: getBlockName(lisboa5), r: 180 },
      ],
      [
        { id: lisboa5, name: getBlockName(lisboa5) },
        { id: lisboa3, name: getBlockName(lisboa3) },
        { id: lisboa5, name: getBlockName(lisboa5), r: 180 },
        { id: lisboa5, name: getBlockName(lisboa5), r: 270 },
        { id: lisboa5, name: getBlockName(lisboa5), r: 180 },
        { id: lisboa1, name: getBlockName(lisboa1) },
      ],
      [
        { id: lisboa5, name: getBlockName(lisboa5), r: 270 },
        { id: lisboa5, name: getBlockName(lisboa5), r: 180 },
        { id: lisboa1, name: getBlockName(lisboa1) },
        { id: lisboa1, name: getBlockName(lisboa1) },
        { id: lisboa1, name: getBlockName(lisboa1) },
        { id: lisboa1, name: getBlockName(lisboa1) },
      ],
    ],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  '93beb7dd-edeb-4447-a264-ade07b1b2746': {
    name: 'Lisboa All-002',
    module: [
      [
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
      ],
      [
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
      ],
      [
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
      ],
      [
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
      ],
      [
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
      ],
      [
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
      ],
      [
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
      ],
      [
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 180 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
      ],
      [
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 0 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 90 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa3, name: getBlockName(lisboa3), r: 0 },
        { id: lisboa2, name: getBlockName(lisboa2), r: 90 },
        { id: lisboa4, name: getBlockName(lisboa4), r: 270 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
        { id: lisboa1, name: getBlockName(lisboa1), r: 0 },
      ],
    ],
    customBlocks: [lisboa1, lisboa2, lisboa3, lisboa4, lisboa5],
  },

  // Porto

  '97210965-f0e7-4142-bc58-c0eef97f07b8': {
    name: 'Porto 1-001',
    module: [[{ id: porto1, name: getBlockName(porto1) }]],
    customBlocks: [porto1, lisboa1],
  },

  'fc41f36d-beb7-4920-a650-c2b13beb6bd2': {
    name: 'Porto 1-002',
    module: [[{ id: porto1, name: getBlockName(porto1), r: 90 }]],
    customBlocks: [porto1, lisboa1],
  },

  '515c1b94-da9d-466b-b354-571968374992': {
    name: 'Porto 1-003',
    module: [
      [
        { id: porto1, name: getBlockName(porto1), r: 90 },
        { id: porto1, name: getBlockName(porto1), r: 0 },
      ],
      [
        { id: porto1, name: getBlockName(porto1), r: 0 },
        { id: porto1, name: getBlockName(porto1), r: 90 },
      ],
    ],
    customBlocks: [porto1, lisboa1],
  },

  '2ee4d11e-c94e-49dd-93b3-2f2fb6b3ebca': {
    name: 'Porto 2-001',
    module: [[{ id: porto2, name: getBlockName(porto2) }]],
    customBlocks: [porto2, lisboa1],
  },

  'd3fb820a-cc5d-40ad-9efd-78c524c9b7b3': {
    name: 'Porto 2-002',
    module: [[{ id: porto2, name: getBlockName(porto2), r: 90 }]],
    customBlocks: [porto2, lisboa1],
  },

  'b2eb9482-17b3-4dae-80a1-85a58de9012a': {
    name: 'Porto 2-003',
    module: [
      [
        { id: porto2, name: getBlockName(porto2), r: 90 },
        { id: porto2, name: getBlockName(porto2), r: 0 },
      ],
      [
        { id: porto2, name: getBlockName(porto2), r: 0 },
        { id: porto2, name: getBlockName(porto2), r: 90 },
      ],
    ],
    customBlocks: [porto2, lisboa1],
  },

  '81bb8afa-9574-45aa-b9be-2f42ccfa3ee8': {
    name: 'Porto 3-001',
    module: [[{ id: porto3, name: getBlockName(porto3) }]],
    customBlocks: [porto3, lisboa1],
  },

  '274bee68-74bd-4776-804e-566b99927346': {
    name: 'Porto 3-002',
    module: [[{ id: porto3, name: getBlockName(porto3), r: 90 }]],
    customBlocks: [lisboa3, porto1],
  },

  '1d12c8b3-1016-4340-b439-70b640f1e367': {
    name: 'Porto 3-003',
    module: [
      [
        { id: porto3, name: getBlockName(porto3), r: 90 },
        { id: porto3, name: getBlockName(porto3), r: 270 },
      ],
    ],
    customBlocks: [porto3, lisboa1],
  },

  '2f096dee-b4c7-4e1e-94fa-a43531ce71e5': {
    name: 'Porto 3-004',
    module: [
      [
        { id: porto3, name: getBlockName(porto3) },
        { id: porto3, name: getBlockName(porto3), r: 180 },
      ],
    ],
    customBlocks: [porto3, lisboa1],
  },

  '12c38751-6815-43ff-8421-75b9c5eed2eb': {
    name: 'Porto 3-005',
    module: [
      [
        { id: porto3, name: getBlockName(porto3), r: 90 },
        { id: porto3, name: getBlockName(porto3), r: 0 },
      ],
      [
        { id: porto3, name: getBlockName(porto3), r: 0 },
        { id: porto3, name: getBlockName(porto3), r: 90 },
      ],
    ],
    customBlocks: [porto3, lisboa1],
  },

  // 'aff5ea63-34c8-40f0-8c65-a510460ba076': {
  //   name: 'Design 402 Large',
  //   fullBlocksOnly: true,
  //   dimensions: { i: `W 2'-8" x H 2'-8"`, m: 'W 81.2 cm x H 81.2 cm' },
  //   blocks: [
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //     { id: 'ea6a6f31-ea62-4cbe-9705-f104dddfbcf9', x: 8, y: 8 },
  //   ],
  //   origin: [0.5, 0.5],
  //   repeat: [[16, 0], [0, 16]],
  //   align: [[16, 0, -8], [16, 0, -8]],
  // },

  // '281d02c2-e7e5-4252-9e7b-2068a366fc01': {
  //   name: 'Design 402 Medium',
  //   fullBlocksOnly: true,
  //   dimensions: { i: `W 2'-0" x H 2'-0"`, m: 'W 61 cm x H 61 cm' },
  //   blocks: [
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //     { id: '4a64a548-bcbb-48d6-8c60-86af1371d164', x: 6, y: 6 },
  //   ],
  //   origin: [0.5, 0.5],
  //   repeat: [[12, 0], [0, 12]],
  //   align: [[12, 0, -6], [12, 0, -6]],
  // },

  // 'cd9ca5e5-ed19-4729-812c-8182ab8fc5c7': {
  //   name: 'Design 402 Small',
  //   fullBlocksOnly: true,
  //   dimensions: { i: `W 1'-4" x H 1'-4" `, m: 'W 40 cm x H 40 cm' },
  //   blocks: [
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //     { id: '3eadae5c-c35d-4f74-a516-a9e0795ac76f', x: 4, y: 4 },
  //   ],
  //   origin: [0.5, 0.5],
  //   repeat: [[8, 0], [0, 8]],
  //   align: [[8, 0, -4], [8, 0, -4]],
  // },
};



// WEBPACK FOOTER //
// ./src/universal/spinneybeck/patterns.js